

export class VehicleLicenseDetailsUpdateInput implements IVehicleLicenseDetailsUpdateInput {
    /** The auto-generated id of the vehicle license details master */
    vehicleLicenseId!: number;
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate!: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate!: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate!: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate!: string;
    /** Expiry message in days */
    showExpiryMessage!: number;
    /** The remark with 500 character limit */
    remark!: string;
    /** Notify for vehicle license.0 for No and 1 for Yes */
    notify!: number;

    constructor(data?: IVehicleLicenseDetailsUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleLicenseId = _data["vehicleLicenseId"];
            this.branchDetailId = _data["branchDetailId"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.licenseIssueDate = _data["licenseIssueDate"];
            this.licenseActivationDate = _data["licenseActivationDate"];
            this.licenseExpiryDate = _data["licenseExpiryDate"];
            this.licenseExtendDate = _data["licenseExtendDate"];
            this.showExpiryMessage = _data["showExpiryMessage"];
            this.remark = _data["remark"];
            this.notify = _data["notify"];
        }
    }

    static fromJS(data: any): VehicleLicenseDetailsUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLicenseDetailsUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleLicenseId"] = this.vehicleLicenseId;
        data["branchDetailId"] = this.branchDetailId;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["licenseIssueDate"] = this.licenseIssueDate;
        data["licenseActivationDate"] = this.licenseActivationDate;
        data["licenseExpiryDate"] = this.licenseExpiryDate;
        data["licenseExtendDate"] = this.licenseExtendDate;
        data["showExpiryMessage"] = this.showExpiryMessage;
        data["remark"] = this.remark;
        data["notify"] = this.notify;
        return data; 
    }
}

export interface IVehicleLicenseDetailsUpdateInput {
    /** The auto-generated id of the vehicle license details master */
    vehicleLicenseId: number;
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The license issue date with 10 character limit */
    licenseIssueDate: string;
    /** The license activation date with 10 character limit */
    licenseActivationDate: string;
    /** The license expiry date with 10 character limit */
    licenseExpiryDate: string;
    /** The license extended date with 10 character limit */
    licenseExtendDate: string;
    /** Expiry message in days */
    showExpiryMessage: number;
    /** The remark with 500 character limit */
    remark: string;
    /** Notify for vehicle license.0 for No and 1 for Yes */
    notify: number;
}

